import getModelReasoningLevels from '@/lib/model/getModelReasoningLevels.js';
import getModelReasoningOptions from '@/lib/model/getModelReasoningOptions.js';

const normalizeThreadComposerSettings = ({ model, reasoning } = {}) => {
  const modelId = model;
  const reasoningEffort = getModelReasoningLevels(modelId).includes(reasoning) ? reasoning : getModelReasoningOptions(modelId)?.[0]?.value || 'high';

  return { modelId, reasoningEffort };
};

export default normalizeThreadComposerSettings;
